//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PageLpPlanup',

  layout: 'page',

  data() {
    return {
      caseList: [
        {
          id: 1,
          title: 'Case 1',
          intro:
            'コロナの影響で外出（外食）を控える人が増えて商品が不足がちになった',
          imgUrl: 'img/tmp/lp-planup-item1.png',
        },
        {
          id: 2,
          title: 'Case 2',
          intro:
            'お惣菜などの新メニューも頼みたいけど、現在の野菜やフルーツの量は減らしたくない',
          imgUrl: 'img/tmp/lp-planup-item2.png',
        },
        {
          id: 3,
          title: 'Case 3',
          intro:
            '類似サービスの複数利用からオフィスでやさいに一本化して経費削減したい',
          imgUrl: 'img/tmp/lp-planup-item3.png',
        },
      ],
    }
  },
}
